let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Y4pF")).then(() => parcelRequire('fIzot'));